module.exports = __webpack_public_path__ + "img/uncompared.690858fc.svg";